import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { SCOREBOARD_ENDPOINT } from '../constants/apiConfig';

function Scoreboard() {
  const [teams, setTeams] = useState([]);
  //const [message, setMessage] = useState({ text: '', type: '' });
  const sortedTeams = [...(teams || [])].sort((a, b) => b.score - a.score);

  const fetchScoreboard = async () => {
    try {
      const response = await axios.get(SCOREBOARD_ENDPOINT);
      setTeams(response.data);
    } catch (err) {
      //setMessage({ text:'An error occurred while fetching the scoreboard', type: 'error' });
    }
  };

  useEffect(() => {
    fetchScoreboard();
    const intervalId = setInterval(fetchScoreboard, 10000); // Fetch data every 10 seconds

    return () => clearInterval(intervalId); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4 text-center text-white">PUNTAJES POR EQUIPO</h2>
      {teams && teams.length > 0 ? (
        <div className="rounded-md overflow-auto bg-blue-950">
            <table className="w-full table-auto"> 
              <thead>
                <tr className="bg-blue-700 dark:bg-blue-600">
                  <th className="font-bold p-4 pb-3 text-lg text-white text-left">Rank</th>
                  <th className="font-bold p-4 pb-3 text-lg text-white text-center">Team</th>
                  <th className="font-bold p-4 pb-3 text-lg text-white text-center">Score</th>
                </tr>
              </thead>
              <tbody>
                {sortedTeams.map((team, index) => (
                  <tr className="bg-white dark:bg-gray-900" key={team.id}>
                    <td className="font-bold border-b border-slate-200 p-4 pl-8 text-lg text-slate-500 ">{index + 1}</td>
                    <td className="font-bold border-b border-slate-200 p-4 pl-8 text-lg text-slate-500  text-center">{team.name}</td>
                    <td className="font-bold border-b border-slate-200 p-4 pl-8 text-lg text-slate-500  text-center">{team.score}</td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
      ) : (
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">No teams found</div>
      )}
    </div>
  );
}

export default Scoreboard;
